import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const LABELS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('LABELS');
export const LABELS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	LABELS_CRUD_ACTION_CONSTANTS
);
